<template>
  <div class="main-container">
    <div class="cheater-search">
      <div class="cheater-search__left">
        <main-menu></main-menu>
      </div>
      <div class="cheater-search__right">
        <div class="cheater-search-page">
          <div class="form">
            <div class="form__row">
              <div class="form__input-box">
                  <label class="form__label">User Name (as displayed in arena leaderboard)</label>
                  <input type="text" class="form__input"  v-model="searchName">
              </div>

              <div class="form__input-box">
                  <label class="form__label">Score</label>
                  <input type="number" class="form__input" v-model="searchScore">
              </div>
              <div class="form__input-box">
                  <label class="form__label">Product</label>
                  <v-select label="Select a product"
                            v-model="searchProduct"
                            :items="products"
                            dense>
                  </v-select>
              </div>
              <div class="form__input-box">
                <label class="form__label">Domain (not required)</label>
                <input type="text" class="form__input" v-model="searchDomain">
              </div>
            </div>
            <div class="form__row">
              <div class="form__input-box">
                <div class="btns-row">
                  <button class="ark-btn ark-btn--default"
                          @click="searchData()">
                    <Loader v-if="isLeaderboardLoadInProgress"></Loader>
                    <span v-else>Find leaderboard entries</span>
                  </button>
                  <button class="ark-btn ark-btn--danger"
                      @click="deleteData()"
                      v-if="entries.length > 0 && $checkRoles(['Administrator'])">
                      <Loader v-if="isLeaderboardDeleteInProgress"></Loader>
                      <span v-else>Delete All</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!isLeaderboardLoadInProgress" class="form">
            <div class="form__row">
              <div class="log-table-container">
                <v-table class="paleBlueRows"
                        :data="entries">
                    <thead slot="head">
                        <th>Name</th>
                        <th>Score</th>
                        <th>Slug</th>
                        <th>Time Frame</th>
                        <th>Leaderboard Table Name</th>
                        <th>LeaderboardUser Table Name</th>
                    </thead>
                    <tbody slot="body" slot-scope="{displayData}">
                        <tr v-for="row in displayData" :key="row.rowKey">
                          <td>{{ row.name }}</td>
                          <td>{{ row.score }}</td>
                          <td>{{ row.slug }}</td>
                          <td>{{ row.timeFrame }}</td>
                          <td>{{ row.leaderboardTableName }}</td>
                          <td>{{ row.leaderboardUserTableName }}</td>
                        </tr>
                        <tr v-if="nothingFound">
                          <td colspan="6">
                            <h3>
                              Nothing found.
                            </h3>
                          </td>
                        </tr>
                        <tr v-if="deleteSuccess">
                          <td colspan="6">
                            <h3>
                              Entries deleted successfully.
                            </h3>
                          </td>
                        </tr>
                    </tbody>
                </v-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../config'
  import Loader from '../Loader/Loader.vue'
  import MainMenu from '../MainMenu/MainMenu.vue'

  export default {
    components: {MainMenu, Loader},
    name: 'CheaterSearch',
    props: [],
    data () {
      return {
        entries: [],
        searchName: null,
        searchScore: null,
        searchDomain: null,
        searchProduct: null,
        nothingFound: false,
        deleteSuccess: false,
        productCopy: null,
        isLeaderboardLoadInProgress: false,
        isLeaderboardDeleteInProgress: false,
        products: ['AARP', 'Arena']
      }
    },
    created: function () {

    },
    methods: {
      searchData: function () {
        if (!this.searchName || !this.searchScore || !this.searchProduct) {
          return
        }
        this.isLeaderboardLoadInProgress = true
        this.nothingFound = false
        this.deleteSuccess = false
        this.entries = []
        const domainParam = this.searchProduct === 'Arena' && this.searchDomain ? `&domain=${encodeURI(this.searchDomain)}` : ``
        const serviceUrl = `${config.apiUrl}/score/list?userName=${encodeURI(this.searchName)}&score=${this.searchScore}&product=${this.searchProduct}` + domainParam + `&r=` + Math.random()
        this.$http.get(
          serviceUrl,
           { timeout: 3600000 })
          .then(response => {
            this.entries = response.body
            if (this.entries.length === 0) {
              this.nothingFound = true
            }
            this.productCopy = this.searchProduct;
            this.isLeaderboardLoadInProgress = false
          }, error => {
            this.isLeaderboardLoadInProgress = false
            console.log(error)
          })
      },
      deleteData: function () {
        this.isLeaderboardDeleteInProgress = true
        this.deleteSuccess = false
        this.$http.delete(`${config.apiUrl}/score/delete?product=${this.productCopy}`, {body: this.entries})
          .then(response => {
            this.entries = []
            this.deleteSuccess = true
            this.isLeaderboardDeleteInProgress = false
          }, error => {
            this.isLeaderboardDeleteInProgress = false
            console.log(error)
          })
      }
    }
  }
</script>

<style scoped lang="scss" src="./CheaterSearch.scss">

</style>
<style scoped lang="css" src="../../common-styles/smart-table.css">

</style>
